/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentCardManageResultProcessParamsApiModel {
  /**
   * One time client operation token (for stripe only)
   */
  client_secret?: string;
  /**
   * Integration type used for operation (for stripe only)
   */
  integration_type?: PaymentCardManageResultProcessParamsApiModelIntegrationTypeEnum;
  /**
   * Setup intent ID (for stripe only)
   */
  setup_external_id?: string;
}
export enum PaymentCardManageResultProcessParamsApiModelIntegrationTypeEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
